<template>
  <div class="web_bottom_box">
    <div class="web_bottom_up">
      <div class="bottom_wechat_box">
        <span>扫码联系我们</span>
        <img src="../../assets/image/index/newWeChatImg.png" style="-webkit-user-drag: none" alt=""/>
      </div>
      <div class="bottom_menu_box">
        <div class="one_menu_list" v-for="(item,index) in bottomMenuList" :key="index">
          <div class="menu_list_title">
            <span>{{ item.title }}</span>
          </div>
          <div class="menu_list_list">
            <div v-for="(list,j) in item.menuList" :key="j">
              <span v-if="item.id===4">{{ list.content }}</span>
              <a :href="list.href" v-else>{{ list.content }} </a>
            </div>

          </div>
        </div>
      </div>
      <div class="small_bottom_content">
        <div class="one_small_bottom" v-for="(item,index) in smallMenuList" :key="index"  @click="checkIcon(item.id)">
          <div style="width: 32px;height: 32px;padding: 0 5px">
            <img :src="item.icon" style="width: 100%;height: 100%" alt=""/>
          </div>
          <span style="font-size: 12px;color: #FFFFFF" v-if="item.id===1||item.id===3">{{ item.title }}</span>
          <span style="font-size: 12px;color: #FFFFFF" v-else v-clipboard="item.title" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">{{ item.title }}</span>
        </div>
      </div>
    </div>
    <div class="web_bottom_down">
      <span class="small_web_span">© 2018 - 2021 厦门乐榜网络科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #FFFFFF;text-decoration: none">备案号：{{ icpName }}</a></span>
    </div>
    <div class="wechat_dialog">
      <el-dialog
        title=""
        :visible.sync="wechatDialog"
        width="70%"
        center>
       <img src="../../assets/image/index/newWeChatImg.png" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import {icpName} from '../../../static/js/distinguishWeb'


export default {
  name: "foot",
  data(){
    return{
      bottomMenuList:[
        {id:1,title:'首页',menuList:[
            {key:1,content:'数据智能化应用场景',href:'/#intelligent_scene'},
            {key:2,content:'案例展示',href:'/#case_display'},
            {key:3,content:'企业实力数据',href:'/#company_data'},
            {key:4,content:'数字化服务流程',href:'/#digital_service'},
            {key:5,content:'合作单位',href:'/#cooperative_unit'},
          ]},
        {id:2,title:'案例展示',menuList:[
            {key:1,content:'智慧社区',href:'/smartCommunity'},
            {key:2,content:'BIG DATA',href:'/bigData'},
            // {key:3,content:'小应用矩阵',href:'/#intelligent_scene'},
          ]},
        {id:3,title:'关于我们',menuList:[
            {key:1,content:'公司介绍',href:'/companyIntroduce#brief_introduction'},
            {key:2,content:'企业文化',href:'/companyIntroduce#culture'},
          ]},
        {id:4,title:'联系我们',menuList:[
            {key:1,content:'地点：厦门乐榜网络科技有限公司'},
            {key:2,content:'邮编：361006'},
            {key:3,content:'邮箱：lyq@xmlebang.com'},
            {key:4,content:'电话：0592-5535810'},
            {key:5,content:'服务时间：9:00-18:30'},
          ]},
      ],
      smallMenuList:[
        {id:1,icon:require('../../assets/image/index/smallWechat.png'),title:'微信联系我们'},
        {id:2,icon:require('../../assets/image/index/smallPhone.png'),title:'0592-5535810'},
        {id:3,icon:require('../../assets/image/index/position.png'),title:'厦门乐榜网络科技有限公司'},
        {id:4,icon:require('../../assets/image/index/email.png'),title:'lyq@xmlebang.com'},
      ],
      wechatDialog:false,
      icpName:icpName ? icpName : ''
    }
  },
  methods:{
    checkIcon(id){
      let that=this;
      if(id===1){
        that.wechatDialog=true;
      }
    },
    onCopySuccess(){
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    onCopyError(){
      this.$message.error('复制失败');
    },
  }
}
</script>

<style scoped>
.web_bottom_box{
  width: 100%;
  height: 440px;
  background-color: #242A32;
}
.web_bottom_up{
  width: 100%;
  height: 358px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.web_bottom_down{
  width: 100%;
  height: 82px;
  background-color: #191E22;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 82px;
}
.bottom_wechat_box{
  width: 201px;
  height: 263px;
  text-align: center;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_wechat_box img{
  width: 80%;
  margin-top: 44px;
}

.bottom_menu_box{
  width: 845px;
  height: 263px;
  margin-left: 93px;
  display: flex;
}
.one_menu_list{
  width: 25%;
  height: 263px;
}
.menu_list_title{
  width: 100%;
  color: #F5F6F9;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
}
.menu_list_list{
  width: 100%;
  margin-top: 34px;
  color: white;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 26px;
}
.menu_list_list>div{
  display: block;
  width: 100%;
  height: 33px;
}
.menu_list_list a,.menu_list_list span{
  width: 100%;
  display: inline;
  color: #DEE1E6;
  text-decoration: none
}
.menu_list_list a:hover{
  color: #5CA4FF;
}

.wechat_dialog /deep/ .el-dialog--center .el-dialog__body {
  text-align: initial;
   padding: 15px 5px;
}
.wechat_dialog /deep/ .el-dialog__body {
  padding: 25px 5px;
}
@media (min-width: 1200px) {
.small_bottom_content{
  display: none;
}
}
@media  (min-width: 979px) and (max-width: 1200px)  {
  .bottom_wechat_box{
    width: 180px;
    height: 263px;
    text-align: center;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .bottom_menu_box{
    width: 750px;
    height: 263px;
    margin-left: 50px;
    display: flex;
  }
  .menu_list_list{
    width: 100%;
    margin-top: 34px;
    color: white;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 26px;
  }
  .small_bottom_content{
    display: none;
  }
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .bottom_wechat_box{
   display: none;
  }
  .bottom_menu_box{
    width: 600px;
    height: 263px;
    margin: 0 auto;
    display: flex;
  }
  .menu_list_list{
    width: 100%;
    margin-top: 34px;
    color: white;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    font-size: 10px;
    line-height: 26px;
  }
  .small_bottom_content{
    display: none;
  }
  .one_menu_list{
    width: 23%;
  }
  .one_menu_list:nth-of-type(4){
    width: 31%;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 767px) {
  .web_bottom_box{
    width: 100%;
    height: 282px;
    background-color: #242A32;
  }
  .bottom_wechat_box{
    display: none;
  }
  .bottom_menu_box{
    display: none;
  }
  .web_bottom_up{
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .web_bottom_box{
    width: 100%;
    height: 202px;
    background-color: #242A32;
  }
  .web_bottom_up{
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .web_bottom_down{
    width: 100%;
    height: 84px;
    background-color: #191E22;
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
  }
  .small_web_span{
    width: 245px;
    line-height: 14px;
    text-align: center;
    display: block;
    margin: 0 auto;
  }
  .small_bottom_content{
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .one_small_bottom{
    width: 50%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .web_bottom_box{
    width: 100%;
    height: 202px;
    background-color: #242A32;
  }
  .web_bottom_up{
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .web_bottom_down{
    width: 100%;
    height: 84px;
    background-color: #191E22;
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
  }
  .small_web_span{
    width: 245px;
    line-height: 14px;
    text-align: center;
    display: block;
    margin: 0 auto;
  }
  .small_bottom_content{
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .one_small_bottom{
    width: 50%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/foot.vue